module.exports = __webpack_public_path__ + "static/media/60 - Nu Guinea - Ddoje Facce.298248b5.mp3";